import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Cell,
  Legend,
  Pie,
  PieChart,
  Sector,
  Tooltip,
} from 'recharts';

import { IconList } from '@nazka/nazka.mapframe.components';
import { calculateRiskDistribution } from '../BuildingDamages/building-damages.utils';

import './risk-distribution-graph.styl';
import { FLASH_FLOOD_LEGEND_ITEMS } from '../Legend/legend.constants';

function renderActiveShape(props) {
  const {
    cx,
    cy,
    endAngle,
    fill,
    innerRadius,
    outerRadius,
    startAngle,
  } = props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 2}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
}

function renderTooltip(props) {
  const { payload, active } = props;

  if (!active) {
    return null;
  }

  const { name, value } = payload[0];

  return (
    <div className="cost-graph__tooltip">
      {`${name}: ${value}`}
    </div>
  );
}

function RiskDistributionGraph({ currentSelectedDamageLayer, width, height }) {
  const [activeIndex, setActiveIndex] = useState(undefined);
  
  const {
    features, 
  } = currentSelectedDamageLayer;
  const riskLevels = useMemo(() => calculateRiskDistribution(features), [features]);
  
  return (
    <div className="risk-distribution-graph">
      <div className="risk-distribution-graph__graph-wrapper">
        <IconList
          className="legend__classes"
          items={FLASH_FLOOD_LEGEND_ITEMS}
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            padding: '0 6px',
            alignItems: 'start',
            li: {
              fontSize: '12px',
              '> div:first-of-type': {
                paddingRight: '5px',
              },
            },
          }}
        />
        <PieChart width={width || 300} height={height || 200}>
          <Pie
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            data={riskLevels}
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={90}
            dataKey="value"
            onMouseEnter={(_, index) => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(undefined)}
          >
            {riskLevels.map(({ color }) => <Cell fill={color} />)}
          </Pie>
          {/* <Legend verticalAlign="middle" align="left" layout="vertical" /> */}
          <Tooltip content={renderTooltip} />
        </PieChart>
      </div>
    </div>
  )
}

export default RiskDistributionGraph